import { TokenStatus, useRepositoryMutation } from '@mews-commander/data-access';
import { useLocalizeOffsetValues } from '@mews-commander/ui';
import { DurationService, lt, showErrorAlert, showSuccessAlert } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';

const tokenStatusTextKeyMap: Record<TokenStatus, Mews.TextKey> = {
    [TokenStatus.Fresh]: TextKey.TokenStatusFreshToastContent,
    [TokenStatus.Sent]: TextKey.TokenStatusSentToastContent,
    [TokenStatus.Valid]: TextKey.TokenStatusValidToastContent,
};

export const useRequestActionAuthorization = (params?: { onSuccess?: () => void }) => {
    const localizeOffsetValues = useLocalizeOffsetValues({
        format: 'long',
        timeUnits: ['days', 'hours', 'minutes', 'seconds'],
    });

    return useRepositoryMutation('users', 'requestActionAuthorization', {
        onSuccess: (data) => {
            const alertTitle = lt(tokenStatusTextKeyMap[data.tokenStatus], {
                remainingTimeSpan: localizeOffsetValues(DurationService.parse(data.remainingTimeSpan ?? '')),
            });

            if (data.tokenStatus === TokenStatus.Fresh) {
                showErrorAlert({ title: alertTitle });
            } else {
                showSuccessAlert({ title: alertTitle });
            }

            params?.onSuccess?.();
        },
    });
};
